/**
 * Enum for progress bar color combinations.
 */
export enum ProgressBarColorCombination {
  /**
   * Yellow foreground with grey background.
   */
  YellowForegroundWithGreyBackground = 'YellowForegroundWithGreyBackground',

  /**
   * Yellow foreground with green background.
   */
  YellowForegroundWithGreenBackground = 'YellowForegroundWithGreenBackground',

  /**
   * Green foreground with grey background.
   */
  GreenForegroundWithGreyBackground = 'GreenForegroundWithGreyBackground',

  /**
   * Green foreground with green background.
   */
  GreenForegroundWithGreenBackground = 'GreenForegroundWithGreenBackground',
}
